<script setup lang="ts">
import { EmbeddingsStatusCode, LoadStatusCode, MetadataIndexingStatusCode } from "~/classes/entity"

const props = defineProps({
  files: null
})

/** This could be undefined, implying the file is still indexing */
const status = computed(() => first(props.files)?.searchIndexingStatus())
const sameValue = computed(() => identical(Object.values(props.files).map(f => f.searchIndexingStatus())))
const sameValueNotARoot = computed(() => sameValue.value && !first(props.files)?.isRootFolder())
</script>

<template>
  <panel-details-property-section
    v-if="sameValue && sameValueNotARoot"
    class="search-indexing-status-container"
  >
    <template #header>
      Intelligence Features
    </template>
    <panel-details-property
      v-if="status?.metadataIndexingStatus !== MetadataIndexingStatusCode.Unset"
      label="Metadata"
    >
      <template v-if="status?.metadataIndexingStatus === MetadataIndexingStatusCode.Success">
        <icon-action
          type="check"
          size="xs"
          class="success"
        />
      </template>
      <template v-else-if="status?.metadataIndexingStatus">
        <icon-action
          type="cross"
          size="xs"
          class="failed"
        />
      </template>
      <template v-else>
        <interface-spinner class="loading" />
      </template>
    </panel-details-property>
    <panel-details-property
      v-if="status?.loadStatus !== LoadStatusCode.Unknown"
      label="Content"
    >
      <template v-if="status?.loadStatus === LoadStatusCode.Success">
        <icon-action
          type="check"
          size="xs"
          class="success"
        />
      </template>
      <template v-else-if="status?.loadStatus">
        <icon-action
          type="cross"
          size="xs"
          class="failed"
        />
      </template>
      <template v-else>
        <interface-spinner class="loading" />
      </template>
    </panel-details-property>
    <panel-details-property
      v-if="status?.embeddingsStatus !== EmbeddingsStatusCode.Unset"
      label="Similarity Search"
    >
      <template v-if="status?.embeddingsStatus === EmbeddingsStatusCode.Success">
        <icon-action
          type="check"
          size="xs"
          class="success"
        />
      </template>
      <template v-else-if="status?.embeddingsStatus">
        <icon-action
          type="cross"
          size="xs"
          class="failed"
        />
      </template>
      <template v-else>
        <interface-spinner class="loading" />
      </template>
    </panel-details-property>
  </panel-details-property-section>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.search-indexing-status-container
  @apply

.success
  @apply text-$global-green-primary
.failed
  @apply text-$global-red-primary
.not-applicable
  @apply text-[#{$global-t-tertiary}]
.loading
  @apply h-3 w-3
</style>
